import { BREACH_SOURCES } from './_barrel.js';

        function breachContext(name) {
            if (!name) return null;
            const k = String(name).toLowerCase().trim();
            for (const key in BREACH_SOURCES) { if (k.includes(key)) return BREACH_SOURCES[key]; }
            // Domain-shaped but unknown: still say it's a website, just no profile.
            if (/\.[a-z]{2,}$/i.test(k) && !k.includes(" ")) {
                return { kind: "site breach", text: "Appears to be the website " + name + ". We don't hold a profile for this specific site — treat it as a website breach and judge it on how recent it is and whether the password was reused." };
            }
            return null;
        }

export { breachContext };
